import { render, staticRenderFns } from "./ProductFormTabBasics.vue?vue&type=template&id=bcdce0fe&scoped=true"
import script from "./ProductFormTabBasics.vue?vue&type=script&lang=js"
export * from "./ProductFormTabBasics.vue?vue&type=script&lang=js"
import style0 from "./ProductFormTabBasics.vue?vue&type=style&index=0&id=bcdce0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdce0fe",
  null
  
)

export default component.exports